<template><section><h2>Curve Line Chart 曲线折线图</h2>
<block-demo tip="" source="const data = [
  { date: &#39;05-01&#39;, catgory: &#39;图例一&#39;, sales: 15.2 },
  { date: &#39;05-02&#39;, catgory: &#39;图例一&#39;, sales: 39.2 },
  { date: &#39;05-03&#39;, catgory: &#39;图例一&#39;, sales: 51.2 },
  { date: &#39;05-04&#39;, catgory: &#39;图例一&#39;, sales: 65.2 },
  { date: &#39;05-05&#39;, catgory: &#39;图例一&#39;, sales: 55.2 },
  { date: &#39;05-06&#39;, catgory: &#39;图例一&#39;, sales: 75.2 },
  { date: &#39;05-07&#39;, catgory: &#39;图例一&#39;, sales: 95.2 },
  { date: &#39;05-08&#39;, catgory: &#39;图例一&#39;, sales: 65.2 },
  { date: &#39;05-01&#39;, catgory: &#39;图例二&#39;, sales: 20.2 },
  { date: &#39;05-02&#39;, catgory: &#39;图例二&#39;, sales: 49.2 },
  { date: &#39;05-03&#39;, catgory: &#39;图例二&#39;, sales: 57.2 },
  { date: &#39;05-04&#39;, catgory: &#39;图例二&#39;, sales: 55.2 },
  { date: &#39;05-05&#39;, catgory: &#39;图例二&#39;, sales: 75.2 },
  { date: &#39;05-06&#39;, catgory: &#39;图例二&#39;, sales: 95.2 },
  { date: &#39;05-07&#39;, catgory: &#39;图例二&#39;, sales: 110.2 },
  { date: &#39;05-08&#39;, catgory: &#39;图例二&#39;, sales: 85.2 }
]

const { Chart, Line, Axis, Legend, Tooltip, theme } = qcharts
//修改全局样式
theme.set({
  visuals: {
    Line: {
      styles: {
        line: { lineWidth: 2 }
      }
    }
  }
})

const chart = new Chart({
  container: &#39;#app&#39;
})

chart.source(data, {
  row: &#39;catgory&#39;,
  value: &#39;sales&#39;,
  text: &#39;date&#39;
})

const line = new Line()
line.style(&#39;line&#39;, function(attrs, data, i) {
  if (i === 1) {
    return { smooth: true }
  }
})

const axisBottom = new Axis().style(&#39;grid&#39;, false)
const tooltip = new Tooltip()
const legend = new Legend()
const axisLeft = new Axis({ orient: &#39;left&#39; }).style(&#39;axis&#39;, false).style(&#39;scale&#39;, false)

chart.append([line, axisBottom, axisLeft, tooltip, legend])
"><pre v-pre><code v-pre class="language-javascript"><span class="hljs-keyword">const</span> data = [
  { <span class="hljs-attr">date</span>: <span class="hljs-string">'05-01'</span>, <span class="hljs-attr">catgory</span>: <span class="hljs-string">'图例一'</span>, <span class="hljs-attr">sales</span>: <span class="hljs-number">15.2</span> },
  { <span class="hljs-attr">date</span>: <span class="hljs-string">'05-02'</span>, <span class="hljs-attr">catgory</span>: <span class="hljs-string">'图例一'</span>, <span class="hljs-attr">sales</span>: <span class="hljs-number">39.2</span> },
  { <span class="hljs-attr">date</span>: <span class="hljs-string">'05-03'</span>, <span class="hljs-attr">catgory</span>: <span class="hljs-string">'图例一'</span>, <span class="hljs-attr">sales</span>: <span class="hljs-number">51.2</span> },
  { <span class="hljs-attr">date</span>: <span class="hljs-string">'05-04'</span>, <span class="hljs-attr">catgory</span>: <span class="hljs-string">'图例一'</span>, <span class="hljs-attr">sales</span>: <span class="hljs-number">65.2</span> },
  { <span class="hljs-attr">date</span>: <span class="hljs-string">'05-05'</span>, <span class="hljs-attr">catgory</span>: <span class="hljs-string">'图例一'</span>, <span class="hljs-attr">sales</span>: <span class="hljs-number">55.2</span> },
  { <span class="hljs-attr">date</span>: <span class="hljs-string">'05-06'</span>, <span class="hljs-attr">catgory</span>: <span class="hljs-string">'图例一'</span>, <span class="hljs-attr">sales</span>: <span class="hljs-number">75.2</span> },
  { <span class="hljs-attr">date</span>: <span class="hljs-string">'05-07'</span>, <span class="hljs-attr">catgory</span>: <span class="hljs-string">'图例一'</span>, <span class="hljs-attr">sales</span>: <span class="hljs-number">95.2</span> },
  { <span class="hljs-attr">date</span>: <span class="hljs-string">'05-08'</span>, <span class="hljs-attr">catgory</span>: <span class="hljs-string">'图例一'</span>, <span class="hljs-attr">sales</span>: <span class="hljs-number">65.2</span> },
  { <span class="hljs-attr">date</span>: <span class="hljs-string">'05-01'</span>, <span class="hljs-attr">catgory</span>: <span class="hljs-string">'图例二'</span>, <span class="hljs-attr">sales</span>: <span class="hljs-number">20.2</span> },
  { <span class="hljs-attr">date</span>: <span class="hljs-string">'05-02'</span>, <span class="hljs-attr">catgory</span>: <span class="hljs-string">'图例二'</span>, <span class="hljs-attr">sales</span>: <span class="hljs-number">49.2</span> },
  { <span class="hljs-attr">date</span>: <span class="hljs-string">'05-03'</span>, <span class="hljs-attr">catgory</span>: <span class="hljs-string">'图例二'</span>, <span class="hljs-attr">sales</span>: <span class="hljs-number">57.2</span> },
  { <span class="hljs-attr">date</span>: <span class="hljs-string">'05-04'</span>, <span class="hljs-attr">catgory</span>: <span class="hljs-string">'图例二'</span>, <span class="hljs-attr">sales</span>: <span class="hljs-number">55.2</span> },
  { <span class="hljs-attr">date</span>: <span class="hljs-string">'05-05'</span>, <span class="hljs-attr">catgory</span>: <span class="hljs-string">'图例二'</span>, <span class="hljs-attr">sales</span>: <span class="hljs-number">75.2</span> },
  { <span class="hljs-attr">date</span>: <span class="hljs-string">'05-06'</span>, <span class="hljs-attr">catgory</span>: <span class="hljs-string">'图例二'</span>, <span class="hljs-attr">sales</span>: <span class="hljs-number">95.2</span> },
  { <span class="hljs-attr">date</span>: <span class="hljs-string">'05-07'</span>, <span class="hljs-attr">catgory</span>: <span class="hljs-string">'图例二'</span>, <span class="hljs-attr">sales</span>: <span class="hljs-number">110.2</span> },
  { <span class="hljs-attr">date</span>: <span class="hljs-string">'05-08'</span>, <span class="hljs-attr">catgory</span>: <span class="hljs-string">'图例二'</span>, <span class="hljs-attr">sales</span>: <span class="hljs-number">85.2</span> }
]

<span class="hljs-keyword">const</span> { Chart, Line, Axis, Legend, Tooltip, theme } = qcharts
<span class="hljs-comment">//修改全局样式</span>
theme.set({
  <span class="hljs-attr">visuals</span>: {
    <span class="hljs-attr">Line</span>: {
      <span class="hljs-attr">styles</span>: {
        <span class="hljs-attr">line</span>: { <span class="hljs-attr">lineWidth</span>: <span class="hljs-number">2</span> }
      }
    }
  }
})

<span class="hljs-keyword">const</span> chart = <span class="hljs-keyword">new</span> Chart({
  <span class="hljs-attr">container</span>: <span class="hljs-string">'#app'</span>
})

chart.source(data, {
  <span class="hljs-attr">row</span>: <span class="hljs-string">'catgory'</span>,
  <span class="hljs-attr">value</span>: <span class="hljs-string">'sales'</span>,
  <span class="hljs-attr">text</span>: <span class="hljs-string">'date'</span>
})

<span class="hljs-keyword">const</span> line = <span class="hljs-keyword">new</span> Line()
line.style(<span class="hljs-string">'line'</span>, <span class="hljs-function"><span class="hljs-keyword">function</span>(<span class="hljs-params">attrs, data, i</span>) </span>{
  <span class="hljs-keyword">if</span> (i === <span class="hljs-number">1</span>) {
    <span class="hljs-keyword">return</span> { <span class="hljs-attr">smooth</span>: <span class="hljs-literal">true</span> }
  }
})

<span class="hljs-keyword">const</span> axisBottom = <span class="hljs-keyword">new</span> Axis().style(<span class="hljs-string">'grid'</span>, <span class="hljs-literal">false</span>)
<span class="hljs-keyword">const</span> tooltip = <span class="hljs-keyword">new</span> Tooltip()
<span class="hljs-keyword">const</span> legend = <span class="hljs-keyword">new</span> Legend()
<span class="hljs-keyword">const</span> axisLeft = <span class="hljs-keyword">new</span> Axis({ <span class="hljs-attr">orient</span>: <span class="hljs-string">'left'</span> }).style(<span class="hljs-string">'axis'</span>, <span class="hljs-literal">false</span>).style(<span class="hljs-string">'scale'</span>, <span class="hljs-literal">false</span>)

chart.append([line, axisBottom, axisLeft, tooltip, legend])
</code></pre>
</block-demo></section></template><script>export default {components:{}}</script>